import { render, staticRenderFns } from "./CustomerConsultant.vue?vue&type=template&id=3a9d364a&scoped=true"
import script from "./CustomerConsultant.vue?vue&type=script&lang=js"
export * from "./CustomerConsultant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9d364a",
  null
  
)

export default component.exports